import {
    ApplicationConfig,
    importProvidersFrom,
    inject, LOCALE_ID,
    provideAppInitializer,
    provideExperimentalZonelessChangeDetection
} from "@angular/core";
import {OAuthModule} from "angular-oauth2-oidc";
import {BrowserModule} from "@angular/platform-browser";
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {provideAnimations} from "@angular/platform-browser/animations";
import {provideLuxonDateAdapter} from "@angular/material-luxon-adapter";
import {provideRouter, withViewTransitions} from "@angular/router";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {providePrimeNG} from "primeng/config";
import {AuthService, ConfigurationService} from "@shared/api";
import {authInterceptor, errorsInterceptor} from "@shared/interceptors";
import {routes} from "../routes/routes";
import {themePreset} from "../theme/preset";
import {ConfirmationService, MessageService} from "primeng/api";
import {provideEchartsCore} from "ngx-echarts";
import * as echarts from "echarts/core";
import {ru} from "./ru.locale";
import {tap} from "rxjs";


export const config: ApplicationConfig = {
    providers: [
        importProvidersFrom(BrowserModule, OAuthModule.forRoot({resourceServer: {sendAccessToken: true}})),
        provideRouter(routes, withViewTransitions()),
        provideAppInitializer(() => {
            const configService = inject(ConfigurationService);
            const authService = inject(AuthService);
            return configService.load().pipe(
                tap(() => {
                    authService.configSso();
                })
            );
        }),
        provideAnimations(),
        provideLuxonDateAdapter(),
        {
            provide: LOCALE_ID,
            useValue: "ru"
        },
        provideHttpClient(withInterceptors([authInterceptor, errorsInterceptor])),
        provideExperimentalZonelessChangeDetection(),
        provideAnimationsAsync(),
        providePrimeNG({
            translation: ru,
            theme: {
                preset: themePreset,
                options: {
                    darkModeSelector: ".dark"
                }
            }
        }),
        provideEchartsCore({echarts}),
        MessageService,
        ConfirmationService,
    ]
};
